export default __webpack_public_path__ + "static/media/work-pdf-file@2x.8389db6b.svg";